import utils from 'lib/utils';
import config from 'config';

const { baseUrl } = config;

export const getDashboards = async (params: string) => {
  try {
    const qs = utils.getQs({ Dashboard_Enum: params });
    const url = `${baseUrl}/BioFuelRegistration/api/Dashboard/GetDashboards?${qs}`;
    const res = await utils.fetch(url).ready;
    const resData = await utils.processApiRes(res);
    return resData;
  } catch (err: any) {
    const errors = await utils.processApiErrors(err, '', 'GetDashboards');
    throw errors;
  }
};

export const SaveEULAAcceptance = async (params: string) => {
  try {
    const url = `${baseUrl}/BioFuelRegistration/api/KYC/SaveEULAAcceptance`;
    const res = await utils.fetch(url, {
      method: 'POST',
      body: JSON.stringify(params),
    }).ready;
    const resData = await utils.processApiRes(res);
    return resData;
  } catch (err: any) {
    const errors = await utils.processApiErrors(err, '', 'SaveEULAAcceptance');
    throw errors;
  }
};

export const saveGPAAcceptance = async (params: string) => {
  try {
    const url = `${baseUrl}/BioFuelRegistration/api/KYC/SaveGPAAcceptance`;
    const res = await utils.fetch(url, {
      method: 'POST',
      body: JSON.stringify(params),
    }).ready;
    const resData = await utils.processApiRes(res);
    return resData;
  } catch (err: any) {
    const errors = await utils.processApiErrors(err, '', 'SaveGPAAcceptance');
    throw errors;
  }
};

export const saveGreenChannelAcceptance = async (params: string) => {
  try {
    const url = `${baseUrl}/BioFuelRegistration/api/KYC/SaveGreenChannelAcceptance`;
    const res = await utils.fetch(url, {
      method: 'POST',
      body: JSON.stringify(params),
    }).ready;
    const resData = await utils.processApiRes(res);
    return resData;
  } catch (err: any) {
    const errors = await utils.processApiErrors(err, '', 'SaveGreenChannelAcceptance');
    throw errors;
  }
};
